/**
 * Cookieconsent config
 * https://www.osano.com/cookieconsent/documentation/javascript-api/
 */
window.addEventListener("load", function(){

    const menuLinkCookiesSettings = document.getElementById('cookies-settings');
    if (!menuLinkCookiesSettings) {
        return false;
    }

    let cookiesconsentPopup;
    let type = "opt-in";
    let content = {
        message: "Ce site utilise des cookies essentiels à son fonctionnement. Et souhaite utiliser des cookies de sites partenaires à des fins de suivi de fréquentation.",
        dismiss: "Fermer",
        allow: "Accepter",
        deny: "Refuser les cookies non essentiels",
    }

    if (dntActive()){
        type = 'info',
        content.message = "Vous avez activé le paramètre \"ne pas être pisté (DoNotTrack)\" de votre navigateur.<br>Il vous faudra le désactiver si vous souhaitez pouvoir accepter les cookies.";
    }

    content.message += '<div>Consulter notre <a href="/infos-legales">politique de protection des données personnelles.</a></div>';

    window.cookieconsent.initialise({
        revokable: true,
        type: type,
        content: content,
        showLink: false,
        elements: {
            message: '<div id="cookieconsent:desc" class="cc-message">'+content.message+'</div>',
            dismiss: '<button type="button" tabindex="0" class="cc-btn cc-dismiss">'+content.dismiss+'</button>',
            allow: '<button type="button" tabindex="0" class="cc-btn cc-allow">'+content.allow+'</button>',
            deny: '<button type="button" tabindex="0" class="cc-btn cc-deny">'+content.deny+'</button>',
        },
        onInitialise: function(status) {
            if (this.hasConsented()) {
                loadCookiesRelatedScripts();
            }
        },
        onStatusChange: function(status) {
            if (this.hasConsented()) {
                loadCookiesRelatedScripts();
            };
        },
    }, function (popup) {
        cookiesconsentPopup = popup;
    }, function (err) {
        console.log(err);
    });

    menuLinkCookiesSettings.onclick = function (e) {
        e.preventDefault();
        cookiesconsentPopup.revokeChoice();
    }
});

function dntActive() {
    let dnt_active = parseInt(
        navigator.msDoNotTrack || // Internet Explorer 9 and 10 vendor prefix
        window.doNotTrack || // IE 11 uses window.doNotTrack
        navigator.doNotTrack, // W3C
        10
    );

    return dnt_active === 1;
}

function loadCookiesRelatedScripts() {
    // Plausible
    if (typeof plsbl_instance_url !== 'undefined' && plsbl_instance_url != ''){
        (function(d,s){
            let f=d.getElementsByTagName(s)[0],
                e=d.createElement(s);
            e.defer=true;
            e.dataset.domain=plsbl_dom;
            e.src=plsbl_instance_url+'/js/script.js';
            f.parentNode.insertBefore(e,f);
        })(document, 'script');
    }

    // Google Tag Manager
    if (!dntActive() && typeof ga_gtm !== 'undefined' && ga_gtm != ''){
        (function(w,d,s,l,i){
            w[l] = w[l]||[];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js'
            });
            let f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', ga_gtm);
    }

    // Global site tag (gtag.js) - Google Analytics
    if (!dntActive() && typeof ga_id !== 'undefined' && ga_id != ''){
        (function(d,s){
            let f=d.getElementsByTagName(s)[0],
            e=d.createElement(s);
            e.src='https://www.googletagmanager.com/gtag/js?id='+ga_id;
            f.parentNode.insertBefore(e,f);
        })(document, 'script');
    }
}

function getCookie(name) {
    return document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, "");
}
